import { render } from "./MyRents.vue?vue&type=template&id=74bfe92b"
import script from "./MyRents.vue?vue&type=script&lang=js"
export * from "./MyRents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__